<script setup lang="ts">
import { ref } from 'vue'
import GbButton from '@/components/GbButton.vue'
import { UseClipboard } from '@vueuse/components'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { dispatchCopyEventFrom } from '@/util/copypaste_helpers'

const props = defineProps({
  stringToCopy: {
    type: String,
    required: true
  },
  tooltipText: {
    type: String,
    required: false,
  },
  buttonText: {
    type: String,
    required: true,
    default: 'Copy'
  },
  buttonTheme: {
    type: String,
    required: false,
    default: 'bluePrimary'
  },
  customClass: {
    type: String,
    required: false
  },
  autoHideTooltip: {
    type: Boolean,
    default: false
  },
  autoHideDelay: {
    type: Number,
    default: 2000 // 2 seconds
  },
  size: {
    type: String,
    required: false,
    default: 'md'
  },
  iconClass: {
    type: String,
    required: false,
    default: 'material-icons-round'
  }
})
const emit = defineEmits(['copied'])
const isTooltipOpen = ref(false)


import { getClipboardText } from '@/util/copypaste_helpers'

const clickAction = async (event: MouseEvent, copyFunc: (text: string) => Promise<void>) => {
  const textToCopy = getClipboardText(props.stringToCopy)
  const buttonElement = event.currentTarget as HTMLElement
  if (buttonElement) {
    dispatchCopyEventFrom(buttonElement, true, textToCopy)
  }
  await copyFunc(textToCopy)
  isTooltipOpen.value = true
  if (props.autoHideTooltip) {
    setTimeout(() => {
      isTooltipOpen.value = false
    }, props.autoHideDelay)
  }
  emit('copied')
}
</script>
<template>
  <UseClipboard v-slot="{ copy }" :source="props.stringToCopy">
    <TooltipProvider :disabled="!isTooltipOpen">
      <Tooltip :open="isTooltipOpen" @update:open="(val) => !isTooltipOpen && (isTooltipOpen = val)">
        <TooltipTrigger as-child>
          <GbButton
            type="button"
            :gbTheme="props.buttonTheme"
            :size="props.size"
            :class="props.customClass"
            @click="clickAction($event, copy)"
          >
            <slot name="icon">
              <span :class="props.iconClass" class="mr-1 text-sm">file_copy</span>
            </slot> {{ props.buttonText }}
          </GbButton>
        </TooltipTrigger>
        <TooltipContent v-if="props.tooltipText && props.tooltipText.length > 0">
          <p>{{ props.tooltipText }}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </UseClipboard>
</template>
